import React from 'react';

function Layout({ children, className = "", maxWidth = "max-w-8xl", bg = "bg-primary-light dark:bg-primary-dark", noPadding = false }) {
  return (
    <div className={`min-h-screen ${bg} text-text-light dark:text-text-dark transition-colors duration-200`}>
      <div className={`${maxWidth} mx-auto ${noPadding ? '' : 'px-4 sm:px-6 lg:px-8 py-8'} ${className}`}>
        <main>
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;